<!--
  - Copyright (c) 2024. Haodong JU
  -->

<template>
  <div>
    <tree-node
      :active-name="activeName"
      :tree-node="treeObject"
      @selected="select"
    />
  </div>
</template>

<script>
import TreeNode from '@/views/AadenPages/branding/fragments/BrandingManage/TreeNode.vue'

export default {
  name: 'TreeListView',
  components: { TreeNode },
  props: {
    treeObject: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      activeName: this.treeObject.name
    }
  },
  methods: {
    select (e) {
      this.activeName = e
      this.$emit('selected', e)
    }
  }
}
</script>

<style scoped>

</style>
